import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-unit6-conclusion',
  templateUrl: './unit6-conclusion.component.html',
  styleUrls: ['./unit6-conclusion.component.css']
})
export class Unit6ConclusionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
